const store = {
  debug: true,
  state: {
    loading: false,
    user: null,
    mOpenId: null
  },
  setLoading(value) {
    this.state.loading = value
  },
  setUser (user) {
    this.state.user = user;
  },
  setMOpenId(mOpenId) {
    this.state.mOpenId = mOpenId;
  }
}

export default store;